﻿import { Grid, ImageList } from '@mui/material';
import { FC } from 'react';
import ResultNotFound from '../../../../assets/images/png/NotFound.png';
import { NRFC } from './noResultFoundComponent.classes';

interface IProps {
    errorText?: any;
}

export const NoResultFoundComponent: FC<IProps> = ({ errorText }) => {
    return (
        <Grid
            className={NRFC.root}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                paddingBottom: '2rem',
            }}
            size={{
                xl: 12,
                lg: 12,
                md: 12,
                xs: 12,
            }}
        >
            <Grid
                className={NRFC.imageOuter}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
                sx={{ display: 'flex', justifyContent: 'center' }}
            >
                <ImageList className={NRFC.imageList} style={{ gridTemplateColumns: '' }}>
                    <img className={NRFC.image} src={ResultNotFound} alt="Result Not Found" />
                </ImageList>
            </Grid>
            <div className={NRFC.messageWrap} style={{ textAlign: 'center' }}>
                <h3 className={NRFC.title} style={{ color: '#C4C4C4' }}>
                    {errorText}
                </h3>
            </div>
        </Grid>
    );
};

